import React from 'react'; 

const FooterChevrons = ({fit=null}) => (
  <svg className={`keep-in-touch__chevrons ${fit ? 'keep-in-touch__chevrons--fit' : ''}`} viewBox="0 0 1400 315.002">
    <g data-name="Group 1" transform="translate(-724.623 -469.693)">
      <path
        data-name="Rectangle 3"
        transform="translate(1074.623 469.693)"
        className="fill-artillery-red"
        d="M0 0H175V157.501H0z"
      />
      <path
        data-name="Rectangle 4"
        transform="translate(1249.623 469.693)"
        className="fill-drumskin-white"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 2"
        d="M2345.64 627.194l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-1008.517)"
        className="fill-navy-blue"
      />
      <path
        data-name="Rectangle 5"
        transform="translate(1774.623 469.693)"
        className="fill-drumskin-white"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 3"
        d="M3343.088 627.194l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-1480.965)"
        className="fill-fireworks-gold"
      />
      <path
        data-name="Rectangle 1"
        transform="translate(724.623 469.693)"
        className="fill-fireworks-gold"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 1"
        d="M1348.192 627.194l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-536.069)"
        className="fill-navy-blue"
      />
      <path
        data-name="Rectangle 6"
        transform="translate(724.623 627.194)"
        className="fill-drumskin-white"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 4"
        d="M1348.192 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-536.069 -141.736)"
        className="fill-navy-blue"
      />
      <path
        data-name="Rectangle 7"
        transform="translate(1074.623 627.194)"
        className="fill-navy-blue"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 5"
        d="M2013.157 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-851.034 -141.736)"
        className="fill-artillery-red"
      />
      <path
        data-name="Rectangle 8"
        transform="translate(1424.623 627.194)"
        className="fill-thames-blue"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 6"
        d="M2678.123 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-1165.999 -141.736)"
        className="fill-navy-blue"
      />
      <path
        data-name="Rectangle 9"
        transform="translate(1774.623 627.194)"
        className="fill-navy-blue"
        d="M0 0H350V157.501H0z"
      />
      <path
        data-name="Path 7"
        d="M3343.088 926.43l87.5-87.5 87.5 87.5 87.5-87.5v-70l-87.5 87.5-87.5-87.5-87.5 87.5-87.5-87.5v70z"
        transform="translate(-1480.965 -141.736)"
        className="fill-drumskin-white"
      />
      <path
        data-name="Path 8"
        d="M2013.157 557.195l-87.5-87.5v70l87.5 87.5 87.5-87.5v-70z"
        transform="translate(-851.034)"
        className="fill-drumskin-white"
      />
      <path
        data-name="Rectangle 10"
        transform="translate(1599.623 469.693)"
        className="fill-navy-blue"
        d="M0 0H175V157.501H0z"
      />
      <path
        data-name="Path 9"
        d="M3010.6 557.195l-87.5-87.5v70l87.5 87.5 87.5-87.5v-70z"
        transform="translate(-1323.482)"
        className="fill-fireworks-gold"
      />
    </g>
  </svg>
);

export default FooterChevrons;